import apiFetch from '../apiFetch'
export default function (dossierSubTypeId, token) {
  return apiFetch({ endPoint: `saleType/All/${dossierSubTypeId}`, method: 'GET', body: null, token: token })
}
